// Quantity stepper: − [ qty ] +. Big circular touch targets for the tótem.

export function Stepper({
  value,
  min = 0,
  max = 99,
  onChange,
  decLabel,
  incLabel,
}: {
  value: number;
  min?: number;
  max?: number;
  onChange: (next: number) => void;
  decLabel: string;
  incLabel: string;
}) {
  return (
    <div className="stepper">
      <button
        aria-label={decLabel}
        className="stepper__btn"
        disabled={value <= min}
        onClick={() => onChange(Math.max(min, value - 1))}
        type="button"
      >
        −
      </button>
      <span className="stepper__qty">{value}</span>
      <button
        aria-label={incLabel}
        className="stepper__btn"
        disabled={value >= max}
        onClick={() => onChange(Math.min(max, value + 1))}
        type="button"
      >
        +
      </button>
    </div>
  );
}
